export const en = {
    navigation: {
        menu: 'Menu',
    },
    date: {
        day: '0 days | 1 day | {count} days',
    },
    text: {
        in: 'in',
        destination: 'Destination',
        arrivalDeparture: 'Arrival- /Departure',
        duration: 'Duration',
        people: 'Person | People',
        budget: 'Budget',
        price: 'Price',
        transportType: 'Transport Type',
        recommendedTravelTime: 'Recommended In',
        discoverRoute: 'Discover route'
    },
    trip: {
        action: {
            detail: 'Tour planing',
        },
    },
    tour: {
        headline: 'A tour you might like:'
    },
    errorMessages: {
        missingFirstName: 'Please enter your first name',
        missingLastName: 'Please enter your last name',
        missingEmail: 'Please enter your email',
        incorrectEmail: 'Please enter a valid email address',
        invalidEmailDomain: 'This email domain does not exist or is invalid',
        emailPotentiallyIncorrect: 'Are you sure this email address is correct?',
        missingBirthDate: 'Please select your birth date',
        tosNotAccepted: 'Please accept our terms and conditions',
        missingGender: 'Please select a gender',
        missingPhone: 'Please enter your phone number',
        invalidPhone: 'Please enter the phone number in the format shown in the example',
        phoneTooShort: 'Please enter a valid phone number',
    }
};
